export default [
  {
    path: '/popup/:name/:id?',
    name: 'detailPopup',
    component: () => import(/* webpackChunkName:'detail'*/ '@/pages/DetailPopup.vue'),
    meta: {
      rule: 'editor',
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import(/* webpackChunkName:'pages'*/ '@/pages/403.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/500',
    name: '500',
    component: () => import(/* webpackChunkName:'pages'*/ '@/pages/500.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName:'login'*/ '@/pages/Login.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/login-callback',
    name: 'LoginCallback',
    component: () => import(/*webpackChunkName:'login'*/ '@/pages/LoginCallback.vue'),
    meta: {
      anonymous: true,
    },
  },      
  {
    path: '/two-factor-auth',
    name: 'TwoFactorAuth',
    component: () => import(/*webpackChunkName:'login'*/ '@/pages/TwoFactorAuth.vue'),    
    meta: {
    },
  },
  // {
  //   path: '/login-fingov-callback',
  //   name: 'LoginFingovCallback',
  //   component: () => import(/*webpackChunkName:'login'*/ '@/pages/LoginFingovCallback.vue'),
  //   meta: {
  //     anonymous: true,
  //   },
  // },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName:'logout'*/ '@/pages/Logout.vue'),
    meta: {
      anonymous: true,
    },
  },

  {
    path: '/history/history-access',
    name: 'history-access',
    component: () => import(/* webpackChunkName:'logout'*/ '@/pages/HistoryAccess.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/confirmRedirect',
    name: 'confirm-redirect',
    component: () => import('@/pages/ConfirmRedirect.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/terms-privacy',
    name: 'TermsPrivacy',
    component: () => import('@/pages/TermsPrivacy.vue'),
    meta: {},
  },
  {
    path: '/start-using',
    name: 'StartUsing',
    component: () => import('@/pages/StartUsing.vue'),
    meta: {},
  },
    {
    path: '/start-using-ihos',
    name: 'StartUsingIHOS',
    component: () => import('@/pages/StartUsingIHOS.vue'),
    meta: {},
  },
    {
    path: '/start-upgrade-ihos',
    name: 'StartUpgradeIHOS',
    component: () => import('@/pages/StartUpgradeIHOS.vue'),
    meta: {},
  }
];
